import { generateTimestampedCryptoRandomId } from './cryptoRandomId';

const UUID_STORAGE_KEY = 'anonymousUserUuid';
const UUID_UPDATE_INTERVAL = 30 * 60 * 1000;

export const getAnonymousUserId = (isAuthenticated: boolean): string | null => {
  if (isAuthenticated) {
    localStorage.removeItem(UUID_STORAGE_KEY);
    return null;
  }

  const storedUuid = localStorage.getItem(UUID_STORAGE_KEY);
  const now = Date.now();

  if (storedUuid) {
    const storedTimestamp = storedUuid.split('_')[0];
    const timestamp = parseInt(storedTimestamp, 10);
    if (now - timestamp < UUID_UPDATE_INTERVAL) {
      return storedUuid;
    }
  }

  const newUuid = generateTimestampedCryptoRandomId();
  localStorage.setItem(UUID_STORAGE_KEY, newUuid);

  return newUuid;
};
